import React from 'react';

import { Icon } from '@chakra-ui/react';

export const TagIcon = props => (
  <Icon
    viewBox="0 0 512 512"
    w="full"
    h="full"
    color="inherit"
    p="1px"
    {...props}
  >
    <path
      d="M345.9,174.9c15.1,18,41.9,20.3,59.9,5.2c18-15.1,20.3-41.9,5.2-59.9c-15.1-18-41.9-20.3-59.9-5.2
	C333.1,130.1,330.8,156.9,345.9,174.9z M369.3,136.7c6-5,14.9-4.3,20,1.7c5,6,4.2,14.9-1.8,20c-6,5-14.9,4.3-20-1.8
	C362.5,150.7,363.3,141.7,369.3,136.7z M499.1,33.2L279.5,14c-3.7-0.3-7.5,0.9-10.3,3.3L30.3,217.7c-35.9,30.2-40.6,83.8-10.5,119.8
	l109.3,130.2c30.2,35.9,83.8,40.6,119.8,10.5l238.8-200.4c2.9-2.4,4.7-5.9,5-9.6l19.2-219.6l0,0C512.6,40.8,506.9,33.9,499.1,33.2z
	 M465,259.9L230.7,456.5c-24,20.1-59.7,16.9-79.8-7L41.6,319.2c-20.1-24-16.9-59.7,7-79.9L282.8,42.8l199.7,17.5L465,259.9z"
    />
  </Icon>
);
